// src/pages/admin/UserRequests.jsx
import React from 'react';

export default function UserRequests() {
  return (
    <div>
      <h2>User Requests</h2>
      <p>Review and approve user subscription requests here.</p>
    </div>
  );
}
